module.exports = __webpack_public_path__ + "static/media/krieger.e8d837cc.png";